import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface MarkerProps {
    text: string;
}

export const markerKDagVariables = [
    {
        variableName: 'text' as const,
        type: 'string' as const
    }
];

export const markerKDag = (props: MarkerProps) => {
    return (
        <S_Container>
            <S_Text>{props.text}</S_Text>
        </S_Container>
    );
};

const S_Container = styled.div`
    background: #ffffff;
    width: 125px;
    height: 70px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    border: 1px solid #112545;
    box-shadow: 5.68813px 5.68813px 17.0644px rgba(0, 0, 0, 0.25), inset 0px -2.4606px 0px #112545,
        inset 0px 0px 72.808px 9.101px #c0ebfb;
`;

const S_Text = styled.div`
    font-family: ${EFonts.Medium};
    font-size: 15px;
    padding: 0 5px;
    margin: -3px 0 0 0;
    color: #112545;
`;
